"use client";

import posthog from "posthog-js";
import NextError from "next/error";
import { useEffect } from "react";

// Root-layout error boundary: catches exceptions that escape the route-level boundaries
// (including errors thrown by the root layout itself) and reports them to PostHog before
// rendering the default Next.js error page. instrumentation-client.ts already autocaptures
// unhandled exceptions; this covers the React-render boundary path Next.js owns.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags.
    <html lang="en">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
